import React from "react";

import ManageCSPsView from "./ManageCSPsView";

const ManageCSPs = () => {
  return <ManageCSPsView />;
};

export default ManageCSPs;
